// Regional vocabulary: interface strings that differ between countries sharing a language.
// Mexico: "chaqueta" has an unwanted meaning there, so the word is "chamarra".
export const REGIONAL_TEXT = {
  MX: {
    es: {
      categories: { chaquetas: 'Chamarras' },
      seo: { defaultTitle: 'CimonaMía | Moda sostenible — Abrigos, Chamarras, Blazers' },
    },
  },
};

const originals = new Map(); // "lang|path" -> original value, so switching country restores the shared text

const walk = (obj, prefix = '') =>
  Object.entries(obj).flatMap(([k, v]) => (v && typeof v === 'object' ? walk(v, `${prefix}${k}.`) : [[`${prefix}${k}`, v]]));

export function applyRegionalText(i18n, countryCode, language) {
  originals.forEach((value, id) => {
    const [lang, path] = id.split('|');
    i18n.addResource(lang, 'translation', path, value);
  });
  originals.clear();
  const overrides = REGIONAL_TEXT[countryCode]?.[language];
  if (!overrides) return;
  walk(overrides).forEach(([path, value]) => {
    originals.set(`${language}|${path}`, i18n.getResource(language, 'translation', path));
    i18n.addResource(language, 'translation', path, value);
  });
}
